import React, { memo, useMemo } from "react";
import { Button } from "../ui/button";
import { DialogClose, DialogFooter } from "../ui/dialog";

const ActionButtons = memo(
  ({ onConfirm, canConfirm, isLoading, loadingText, confirmText }) => {
    const cancelButtonProps = useMemo(
      () => ({
        variant: "outline",
        disabled: isLoading,
      }),
      [isLoading]
    );

    const confirmButtonProps = useMemo(
      () => ({
        variant: "destructive",
        disabled: !canConfirm || isLoading,
        onClick: onConfirm,
        "aria-disabled": !canConfirm || isLoading,
      }),
      [canConfirm, isLoading, onConfirm]
    );

    const confirmButtonText = useMemo(() => {
      return isLoading ? loadingText : confirmText;
    }, [isLoading, loadingText, confirmText]);

    return (
      <DialogFooter>
        <DialogClose asChild>
          <Button {...cancelButtonProps}>Annuler</Button>
        </DialogClose>
        <Button {...confirmButtonProps}>{confirmButtonText}</Button>
      </DialogFooter>
    );
  }
);

export default ActionButtons;
